import { SeparatorIcon } from '@/lib/icons'

export function Separator() {
  return (
    <div className="flex items-center gap-sm my-md">
      <span className="flex-1 h-px bg-frame" />
      <SeparatorIcon weight="light" size={14} className="text-gold" />
      <span className="flex-1 h-px bg-frame" />
    </div>
  )
}
